const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIntSii(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b261e6e0-4b90-4eab-bd10-12e8baa823a8",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a1680fc0-e921-40f6-9ac6-68d6f2cb73be{fill:#e6e6e6;}.eda84c73-c12f-447d-918d-e19395cbf51b{fill:#0060a2;}.a76dc523-c2f5-46ee-8c9e-de9e0f77422c{fill:#ec5101;}")), /*#__PURE__*/React.createElement("rect", {
    className: "a1680fc0-e921-40f6-9ac6-68d6f2cb73be",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "eda84c73-c12f-447d-918d-e19395cbf51b",
    d: "M10,36.31a.26.26,0,0,0,0-.15c0-1.36,0-2.71,0-4.06V32a.24.24,0,0,1,.15,0c.57.22,1.13.47,1.69.74a10.34,10.34,0,0,0,1.52.58,8,8,0,0,0,1.37.31,3.74,3.74,0,0,0,1.56-.09,1.63,1.63,0,0,0,1.18-1.34,3.56,3.56,0,0,0-.26-2A6.74,6.74,0,0,0,16.1,28.4a11,11,0,0,0-1.69-1.51,13,13,0,0,1-1.92-1.71,7,7,0,0,1-1.31-2.09,5.63,5.63,0,0,1-.34-2.57,8.15,8.15,0,0,1,.27-1.46c0-.11,0-.11.15-.11h5.19a.25.25,0,0,1,.12,0s0,.07,0,.09a1.84,1.84,0,0,0-.15,1.13A3.18,3.18,0,0,0,17.27,22c1.22,1.29,2.46,2.54,3.74,3.77A8.29,8.29,0,0,1,23.11,29a9.72,9.72,0,0,1,.59,3.54,6.92,6.92,0,0,1-1.81,4.55,7.29,7.29,0,0,1-3.56,2.15,8.92,8.92,0,0,1-3,.31,10.36,10.36,0,0,1-5.15-1.74L10,37.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eda84c73-c12f-447d-918d-e19395cbf51b",
    d: "M26,39.6v-.14c0-6.28,0-12.56,0-18.84,0-.18,0-.17.16-.17h6.21c.18,0,.16,0,.16.17V39.44c0,.06,0,.11,0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eda84c73-c12f-447d-918d-e19395cbf51b",
    d: "M35.47,39.6v-19c0-.19,0-.19.19-.19h6.21s.09,0,.13,0V39.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a76dc523-c2f5-46ee-8c9e-de9e0f77422c",
    d: "M42,16a1.26,1.26,0,0,0,0,.33,3.27,3.27,0,0,1-6.42,0A3.27,3.27,0,0,1,41.94,15c0,.16,0,.33.06.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eda84c73-c12f-447d-918d-e19395cbf51b",
    d: "M19.87,12.42H23c.1,0,.11,0,.11.1v6.26c0,.19,0,.16-.17.16H16.72c-.12,0-.13,0-.13-.13V12.59c0-.19,0-.17.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a76dc523-c2f5-46ee-8c9e-de9e0f77422c",
    d: "M29.32,12.42a3.27,3.27,0,1,1-3.27,3.25A3.25,3.25,0,0,1,29.32,12.42Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntSii);
export default __webpack_public_path__ + "static/media/Int_SII.4c6ec4f87ab9608f3dcc5513aedc552f.svg";
export { ForwardRef as ReactComponent };